import React from 'react';

const Info = ({translate, title, content, className}) => (
	<div className={className}>
		<h2 className="section-title">{translate(title)}</h2>
		<p className="regular-text">{translate(content)}</p>
	</div>
);

export default Info;



// WEBPACK FOOTER //
// ./src/components/elements/Skill/Info.js